import { useEffect, useState } from 'react';

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToAuditForm = () => {
    const element = document.getElementById('audit-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/acefa02d7e99ee7f448b2b11e16660b8.jpg"
          alt="Digital Marketing Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628]/95 via-[#2D1B69]/90 to-[#0A1628]/95"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/40"></div>
      </div>

      {/* Geometric Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 border-2 border-white rounded-full"></div>
        <div className="absolute bottom-1/3 right-1/3 w-64 h-64 border-2 border-white rotate-45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className={`lg:col-span-3 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1 className="font-bold text-6xl lg:text-7xl text-white leading-tight mb-6">
              Generate More Leads.<br />
              Drive Real Revenue.<br />
              <span className="text-[#FF6B35]">Dominate Your Market.</span>
            </h1>
            
            <p className="text-xl lg:text-2xl text-white/85 leading-relaxed mb-10 max-w-2xl font-light">
              Data-driven digital marketing strategies that turn clicks into customers and traffic into profit
            </p>

            <div className="flex flex-wrap gap-5">
              <button
                onClick={scrollToAuditForm}
                className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#ff5520] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                Get Free Audit
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
              
              <button
                onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-white hover:text-[#0A1628] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                View Our Work
              </button>
            </div>
          </div>

          <div className="lg:col-span-2 hidden lg:block">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-[#FF6B35]/20 to-transparent rounded-full blur-3xl"></div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
